import basePath from "base_path";
import ActionTypes from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";

export default function organisationFetch(requestor) {
  return createReduxPromiseAction(
    ActionTypes.ORGANISATION_FETCH,
    organisationId =>
      requestor
        .get(`${basePath}/organisation/${organisationId}/config`, {
          withCredentials: true,
        })
        .then(response => {
          return response.data;
        }),
  );
}
